import HttpStatusCodeError from '../errors/HttpStatusCodesError'
import PAID_LEAVE from '../paidLeave/constants'
import { wrapInQuotes, stripMarkdown, convertNbspToSpaces, formatDate } from '../common/helpers'

const httpClient = require('../clients/httpClient')

const getAllPaidLeaveNotifications = async () => {
  const path = '/notifications/paidLeave'

  const httpResult = await httpClient.getJsonResponse({ path })

  if (httpResult.statusCode >= 400) throw new HttpStatusCodeError({ statusCode: httpResult.statusCode, path })

  return {
    notifications: httpResult.body.notifications.map((notification) => ({
      ...notification,
      expirationDate: new Date(notification.expirationDate),
      publishDate: new Date(notification.publishDate),
      dateOfChange: new Date(notification.dateOfChange)
    })),
    total: httpResult.body.total
  }
}

const getCurrentPaidLeaveNotifications = async ({
  companyId,
  pageNumber,
  pageSize,
  searchText,
  sortOptions,
  filterOptions
}) => {
  const path = `/notifications/paidLeave/${companyId}`

  const queryParameters = {
    pageNumber,
    pageSize,
    search: searchText,
    sortOrder: sortOptions.direction,
    sort: sortOptions.field,
    filters: filterOptions.products ? filterOptions.products.filter : ''
  }

  const result = await httpClient.getJsonResponse({
    path,
    queryParameters
  })

  if (result.statusCode >= 400) throw new HttpStatusCodeError({ statusCode: result.statusCode, path })

  return result.body
}

const createNotificationsCsvRows = (tableFormattedLocations) => {
  const rows = []

  rows.push(PAID_LEAVE.NOTIFICATIONS.CSV_HEADER_ROW_VALUES.join(','))

  tableFormattedLocations.map((notification) => {
    notification.paidLeaveType.map((productId) => {
      notification.locationsAffected.map((location) => {
        const productDto = PAID_LEAVE.PRODUCTS.find((product) => product.id === productId)

        rows.push([
          wrapInQuotes(location.locationName),
          wrapInQuotes(location.locationAddress.address1),
          wrapInQuotes(location.locationAddress.address2),
          wrapInQuotes(location.locationAddress.city),
          wrapInQuotes(location.locationAddress.state),
          wrapInQuotes(location.locationAddress.zip),
          wrapInQuotes(location.locationAddress.country),
          wrapInQuotes(productDto && productDto.name),
          wrapInQuotes(notification.jurisdictionName),
          wrapInQuotes(notification.jurisdictionType),
          wrapInQuotes(formatDate(notification.dateOfChange)),
          wrapInQuotes(convertNbspToSpaces(stripMarkdown(notification.content)))
        ].join(','))
      })
    })
  })

  return rows
}

module.exports = {
  createNotificationsCsvRows,
  getCurrentPaidLeaveNotifications,
  getAllPaidLeaveNotifications
}
